export interface Category {
  id: string;
  name: string;
  slug: string;
  tagline: string;
  desc: string;
  icon: string;
  color: string;
  count: number;
  image: string;
}

export const categories: Category[] = [
  {
    id: 'c1',
    name: '恋爱都市',
    slug: 'romance',
    tagline: '心动与日常的碰撞',
    desc: '都市恋爱题材韩漫的官方正版合集，包含校园心动、职场暧昧与治愈系爱情故事，轻松下饭又上头。',
    icon: 'ri-heart-3-line',
    color: 'bg-primary-500',
    count: 1280,
    image: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20webtoon%20illustration%20of%20a%20young%20couple%20standing%20close%20under%20city%20lights%20at%20dusk%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20soft%20glowing%20background%2C%20clean%20manga%20lineart%2C%20romantic%20atmosphere%2C%20high%20detail%20digital%20art&width=900&height=1100&seq=cat-romance-2026&orientation=portrait',
  },
  {
    id: 'c2',
    name: '奇幻冒险',
    slug: 'fantasy',
    tagline: '异世界与热血征途',
    desc: '韩漫奇幻冒险品类正版精选，剑与魔法、异世界穿越与宏大世界观，带你展开一场又一场冒险。',
    icon: 'ri-sparkling-2-line',
    color: 'bg-accent-500',
    count: 965,
    image: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20webtoon%20illustration%20of%20a%20hero%20warrior%20with%20sword%20facing%20a%20magical%20portal%20with%20floating%20islands%2C%20teal%20and%20gold%20color%20palette%2C%20epic%20fantasy%20atmosphere%2C%20clean%20manga%20lineart%2C%20high%20detail%20digital%20art&width=900&height=1100&seq=cat-fantasy-2026&orientation=portrait',
  },
  {
    id: 'c3',
    name: '悬疑惊悚',
    slug: 'thriller',
    tagline: '烧脑反转步步惊心',
    desc: '高能悬疑与惊悚题材韩漫正版推荐，烧脑反转、细思极恐的剧情，适合喜欢脑洞与刺激的读者。',
    icon: 'ri-ghost-2-line',
    color: 'bg-foreground-800',
    count: 712,
    image: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20webtoon%20illustration%20of%20a%20mysterious%20figure%20in%20a%20dark%20rainy%20alley%20with%20moody%20lighting%2C%20charcoal%20and%20amber%20color%20palette%2C%20tense%20thriller%20atmosphere%2C%20clean%20manga%20lineart%2C%20high%20detail%20digital%20art&width=900&height=1100&seq=cat-thriller-2026&orientation=portrait',
  },
  {
    id: 'c4',
    name: '校园青春',
    slug: 'campus',
    tagline: '青春里的小悸动',
    desc: '校园与青春题材正版韩漫合集，友谊、梦想与初恋交织，满是少年气的清新故事。',
    icon: 'ri-school-line',
    color: 'bg-secondary-500',
    count: 830,
    image: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20webtoon%20illustration%20of%20high%20school%20students%20walking%20through%20a%20sunny%20cherry%20blossom%20campus%2C%20cream%20and%20amber%20color%20palette%2C%20bright%20youthful%20atmosphere%2C%20clean%20manga%20lineart%2C%20high%20detail%20digital%20art&width=900&height=1100&seq=cat-campus-2026&orientation=portrait',
  },
  {
    id: 'c5',
    name: '动作武侠',
    slug: 'action',
    tagline: '拳拳到肉的爽感',
    desc: '动作与武侠类韩漫正版精选，热血打斗、江湖恩怨，战斗场面张力十足的硬核故事。',
    icon: 'ri-sword-line',
    color: 'bg-primary-700',
    count: 548,
    image: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20webtoon%20illustration%20of%20a%20martial%20artist%20in%20dynamic%20combat%20pose%20with%20energy%20trails%2C%20coral%20and%20ink%20color%20palette%2C%20powerful%20dynamic%20atmosphere%2C%20clean%20manga%20lineart%2C%20high%20detail%20digital%20art&width=900&height=1100&seq=cat-action-2026&orientation=portrait',
  },
  {
    id: 'c6',
    name: '日常治愈',
    slug: 'daily',
    tagline: '温暖生活的片刻',
    desc: '治愈系日常韩漫正版合集，美食、宠物与平凡生活的温暖瞬间，看完心情都会被点亮。',
    icon: 'ri-sun-line',
    color: 'bg-accent-600',
    count: 690,
    image: 'https://readdy.ai/api/search-image?query=Stylized%20Korean%20webtoon%20illustration%20of%20a%20cozy%20coffee%20shop%20with%20a%20cat%20and%20warm%20pastries%2C%20soft%20beige%20and%20teal%20color%20palette%2C%20warm%20cozy%20healing%20atmosphere%2C%20clean%20manga%20lineart%2C%20high%20detail%20digital%20art&width=900&height=1100&seq=cat-daily-2026&orientation=portrait',
  },
];

export const findCategory = (slug: string): Category | undefined =>
  categories.find((c) => c.slug === slug);